import React from 'react';
import { AlertTriangle, XCircle, Clock } from 'lucide-react';

/**
 * Banner de alerta exibido no topo da aba Férias quando há funcionários
 * com férias vencidas ou próximas do vencimento.
 */
export default function FeriasVencimentoBanner({ dados, loading }) {
  if (loading || !dados || dados.length === 0) return null;

  const vencidas  = dados.filter(d => d.pior_status === 'vencida').length;
  const vencendo  = dados.filter(d => d.pior_status === 'vencendo').length;
  const pendentes = dados.filter(d => d.pior_status === 'pendente').length;

  if (vencidas === 0 && vencendo === 0) return null;

  return (
    <div className="rounded-lg border border-red-200 bg-red-50 p-4 mb-4 flex flex-wrap gap-4 items-center">
      <div className="flex items-center gap-2 text-red-700 font-medium">
        <AlertTriangle className="h-5 w-5 flex-shrink-0" />
        <span>Atenção: há férias com prazo crítico</span>
      </div>

      <div className="flex flex-wrap gap-3 text-sm ml-auto">
        {vencidas > 0 && (
          <div className="flex items-center gap-1.5 text-red-700 font-semibold">
            <XCircle className="h-4 w-4" />
            <span>{vencidas} vencida{vencidas > 1 ? 's' : ''}</span>
          </div>
        )}
        {vencendo > 0 && (
          <div className="flex items-center gap-1.5 text-yellow-700 font-semibold">
            <Clock className="h-4 w-4" />
            <span>{vencendo} vencendo em breve</span>
          </div>
        )}
        {pendentes > 0 && (
          <div className="flex items-center gap-1.5 text-blue-700">
            <Clock className="h-4 w-4" />
            <span>{pendentes} pendente{pendentes > 1 ? 's' : ''}</span>
          </div>
        )}
      </div>
    </div>
  );
}
